/* eslint-disable no-console */
/* eslint-disable max-depth */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';
import qs from 'qs';

import TagInput from './TagInput';
import LocationInput from './LocationInput';
import DateInput from './DateInput';
import GuestInput from '../GuestInput';

import styles from './styles.js';

import {
    container,
    display,
    input,
    position,
    type,
    width
} from '../../../../../commonStyles.js';

import {
    fetchActions,
    filterActions
} from '../../../../../pages/Search/actions';

import { escapeRegexCharacters } from '../methods';

import { convertLocationStringToSlug } from '../../../../../methods';

import { getDomainBounds } from '../data';

const AutosuggestHighlightMatch = require('autosuggest-highlight/match');
const AutosuggestHighlightParse = require('autosuggest-highlight/parse');

class SearchBarLarge extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        date: PropTypes.string,
        domain: PropTypes.string.isRequired,
        fetchSearchResultsAfterLocationChange: PropTypes.func.isRequired,
        fetchSearchResultsAfterSearchParamChange: PropTypes.func.isRequired,
        fetchSearchResultsAfterTagParamChange: PropTypes.func.isRequired,
        guests: PropTypes.number,
        lang: PropTypes.object.isRequired,
        location: PropTypes.string.isRequired,
        selectDate: PropTypes.func.isRequired,
        selectGuests: PropTypes.func.isRequired,
        selectLocation: PropTypes.func.isRequired,
        selectTag: PropTypes.func.isRequired,
        setTagLabel: PropTypes.func.isRequired,
        tagLabel: PropTypes.string,
        tags: PropTypes.object.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        dateInput: {
            visible: false,
            value: this.props.date
        },
        guestInput: {
            visible: false,
            value: this.props.guests
        },
        locationInput: {
            focus: false,
            focusedResultIndex: -1,
            results: [],
            value: this.props.location,
            visible: false
        },
        tagInput: {
            focus: false,
            visible: false,
            results: this.props.tags.defaultTags,
            value: this.props.tagLabel
        }
    }

    componentDidMount() {
        this.autoComplete = new google.maps.places.AutocompleteService();
        this.service = new google.maps.places.PlacesService(
            document.getElementById('placesService')
        );
    }

    displayLocationSuggestions = (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
            console.log(status);
            return;
        }
        const results = predictions.map((prediction, index) => {
            return (
                <li
                    key={shortid.generate()}
                    aria-selected="false"
                    className={`location-result ${css(styles.result, styles.resultTall)}`}
                    id={`location-result_${index}`}
                    role="option"
                    tabIndex="-1"
                    data-location={prediction.description}
                    data-place-id={prediction.place_id}
                    onClick={this.handleLocationClick}
                    onMouseEnter={this.handleResultMouseEnter}
                    onMouseLeave={this.handleResultMouseLeave}
                >
                    <div className={css(styles.textContainer)}>
                        <div className={css(styles.text)}>
                            {prediction.description}
                        </div>
                    </div>
                </li>
            );
        });
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                results
            }
        }));
    }

    escapeKeyBinding = e => {
        if (e.keyCode === 27) {
            this.handleHideLocationInput();
            this.handleHideTagInput();
        }
    }

    handleTagClick = (e, { suggestion }) => {
        this.selectTag(suggestion);
    }

    onGuestOptionClick = e => {
        this.props.selectGuests(e.target.dataset.value);
        this.setState(prevState => ({
            guestInput: {
                ...prevState.guestInput,
                visible: !prevState.guestInput.visible
            }
        }));
        this.props.fetchSearchResultsAfterSearchParamChange(
            this.props.apiUrl,
            this.props.userLang,
            {
                paramSlug: 'guests',
                paramValue: e.target.dataset.value
            },
            this.props.trackingCookieId
        );
    }

    handleHideDateInput = (formattedDate, hasChanged) => {
        setTimeout(() => {
            this.setState({
                dateInput: {
                    ...this.state.dateInput,
                    value: formattedDate,
                    visible: false
                }
            });
            if (hasChanged) {
                this.props.selectDate(formattedDate);
                this.props.fetchSearchResultsAfterSearchParamChange(
                    this.props.apiUrl,
                    this.props.userLang, {
                        paramSlug: 'date',
                        paramValue: formattedDate
                    },
                    this.props.trackingCookieId
                );
            }
        }, 100);
    }

    handleHideLocationInput = () => {
        window.removeEventListener('keyup', this.locationKeyboardScroll);
        window.removeEventListener('keyup', this.escapeKeyBinding);
        // let location;
        // let placeId;
        // if (document.getElementById('autocomplete_SearchBarLarge').value !== '') {
        //     location = document.querySelector('#location-result_0').dataset.location;
        //     placeId = document.querySelector('#location-result_0').dataset.placeId;
        // } else {
        //     location = '';
        //     placeId = null;
        // }
        // this.selectLocation(location, placeId);
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                visible: false
            }
        }));
    }

    handleHideTagInput = () => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                visible: false
            }
        }));
    }

    handleLocationChange = value => {
        if (value !== '') {
            const { domain } = this.props;
            const bounds = getDomainBounds(domain);
            this.locationBiasBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.swLat, bounds.swLon), new google.maps.LatLng(bounds.neLat, bounds.neLon));
            this.autoComplete.getPlacePredictions({
                bounds: this.locationBiasBounds,
                input: value
            }, this.displayLocationSuggestions);
        }
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                value
            }
        }));
    }

    handleLocationClick = e => {
        this.selectLocation(e.target.dataset.location, e.target.dataset.placeId);
    }

    handleShowDateInput = () => {
        this.setState(prevState => ({
            dateInput: {
                ...prevState.dateInput,
                visible: true
            }
        }));
    }

    handleShowLocationInput = () => {
        window.addEventListener('keyup', this.locationKeyboardScroll);
        window.addEventListener('keyup', this.escapeKeyBinding);
        document.getElementById('autocomplete_SearchBarLarge').select();
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                visible: true
            }
        }));
    }

    handleShowTagInput = () => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                visible: true
            }
        }), () => {
            $('#tagsAutocomplete').find('input').select();
        });
    }

    handleResultMouseEnter = e => {
        e.target.style.backgroundColor = '#fafafa';
    }

    handleResultMouseLeave = e => {
        e.target.style.backgroundColor = '#fff';
    }

    locationKeyboardScroll = e => {
        let index = this.state.locationInput.focusedResultIndex;
        if (this.state.locationInput && this.state.locationInput.results && this.state.locationInput.results.length) {
            if (e.keyCode === 40) {
                index += 1;
                if (index < 5) {
                    const elements = document.getElementsByClassName('location-result');
                    if (elements) {
                        for (let i = 0; i < elements.length; i += 1) {
                            elements[i].style.backgroundColor = 'transparent';
                        }
                        const element = document.getElementById(`location-result_${index}`);
                        element.style.backgroundColor = '#fafafa';
                        this.setState(prevState => ({
                            locationInput: {
                                ...prevState.locationInput,
                                focusedResultIndex: index
                            }
                        }));
                    }
                }
            } else if (e.keyCode === 38) {
                index -= 1;
                if (index > -1) {
                    const elements = document.getElementsByClassName('location-result');
                    if (elements) {
                        for (let i = 0; i < elements.length; i += 1) {
                            elements[i].style.backgroundColor = 'transparent';
                        }
                        const element = document.getElementById(`location-result_${index}`);
                        element.style.backgroundColor = '#fafafa';
                        this.setState(prevState => ({
                            locationInput: {
                                ...prevState.locationInput,
                                focusedResultIndex: index
                            }
                        }));
                    }
                }
            } else if (e.keyCode === 13 && (index > -1 && index < 5)) {
                this.selectLocation(
                    document.querySelector(`#location-result_${
                        this.state.locationInput.focusedResultIndex
                    }`).dataset.location,
                    document.querySelector(`#location-result_${
                        this.state.locationInput.focusedResultIndex
                    }`).dataset.placeId
                );
            }
        }
    }

    selectTag = tag => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                value: tag.label,
                visible: false
            }
        }));
        this.props.selectTag(tag);
        this.props.setTagLabel(tag.label);
        this.props.fetchSearchResultsAfterTagParamChange(
            this.props.apiUrl,
            this.props.userLang,
            tag,
            this.props.trackingCookieId
        );
        this.handleHideTagInput();
    }

    selectLocation = (location, placeId) => {
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                focusedResultIndex: -1,
                value: location,
                visible: false
            }
        }));
        if (placeId) {
            this.service.getDetails({
                placeId
            }, (place, status) => {
                if (status && place) {
                    const lat = place.geometry.location.lat();
                    const lng = place.geometry.location.lng();
                    this.props.fetchSearchResultsAfterLocationChange(
                        this.props.apiUrl,
                        this.props.userLang,
                        locationSlug,
                        lat,
                        lng,
                        this.props.trackingCookieId
                    );
                }
            });
        }
        const locationSlug = convertLocationStringToSlug(location);
        this.props.selectLocation(locationSlug);
    }

    toggleGuestPanel = () => {
        this.setState(prevState => ({
            guestInput: {
                ...prevState.guestInput,
                visible: !prevState.guestInput.visible
            }
        }));
    }

    handleTagChange = (event, { newValue }) => {
        this.props.setTagLabel(newValue);
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                value: newValue
            }
        }));
    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                results: this.getSuggestions(value)
            }
        }));
    }

    handleSuggestionsClearRequested = () => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                results: this.props.tags.defaultTags
            }
        }));
    }

    getSuggestions = value => {
        if (value) {
            const escapedValue = escapeRegexCharacters(value.trim());

            if (escapedValue === '') {
                return [];
            }
            const inputLength = escapedValue.length;

            return inputLength === 0 ? [] : this.props.tags.tags.filter(item =>
                item.label.toLowerCase()
                    .slice(0, inputLength) === escapedValue.toLowerCase()
            ).slice(0, 5);
        }
        return this.props.tags.defaultTags;
    }

    getSuggestionValue = suggestion => {
        return `${suggestion.label}`;
    }

    renderSuggestion = (suggestion, { query }) => {
        const matches = AutosuggestHighlightMatch(suggestion, query);
        const parts = AutosuggestHighlightParse(suggestion, matches);
        return (
            <span className={css(styles.textContainer)}>
                <span className={css(styles.text)}>
                    {
                        parts.map(part => {
                            const style = part.highlight ? { color: '#00c8ff' } : {};
                            return (
                                <span
                                    style={style}
                                    key={shortid.generate()}
                                >
                                    {part.text.label}
                                </span>
                            );
                        })
                    }
                </span>
            </span>
        );
    }

    render() {
        return (
            <div className={css(display.block, styles.searchBarLarge)}>
                <div id="placesService" />
                <div
                    className={css(
                        type.base,
                        container.base,
                        container.table,
                        width.full,
                        position.relative
                    )}
                >
                    <div
                        className={
                            this.state.tagInput.visible ?
                                css(container.tableCell, styles.inputExpandedFull) :
                                css(container.tableCell, width.oneThird)
                        }
                    >
                        <TagInput
                            disableOnClickOutside={!this.state.tagInput.visible}
                            getSuggestionValue={this.getSuggestionValue}
                            onHideTagInput={this.handleHideTagInput}
                            onShowTagInput={this.handleShowTagInput}
                            lang={this.props.lang}
                            onTagChange={this.handleTagChange}
                            onSuggestionSelected={this.handleTagClick}
                            onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                            onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                            renderSuggestion={this.renderSuggestion}
                            suggestions={this.state.tagInput.results}
                            tagInput={this.state.tagInput}
                            tagLabel={this.props.tagLabel}
                        />
                    </div>
                    <div
                        className={
                            this.state.locationInput.visible ?
                                css(
                                    container.tableCell,
                                    container.borderLeft,
                                    styles.inputExpandedFull
                                ) :
                                css(
                                    container.tableCell,
                                    container.borderLeft,
                                    width.oneThird
                                )
                        }
                    >
                        <LocationInput
                            disableOnClickOutside={!this.state.locationInput.visible}
                            onLocationChange={this.handleLocationChange}
                            onHideLocationInput={this.handleHideLocationInput}
                            onShowLocationInput={this.handleShowLocationInput}
                            lang={this.props.lang}
                            locationInput={this.state.locationInput}
                        />
                    </div>
                    <div
                        className={
                            this.state.dateInput.visible ?
                                css(
                                    container.tableCell,
                                    container.borderLeft,
                                    container.borderRight,
                                    styles.inputExpanded
                                ) :
                                css(
                                    container.tableCell,
                                    container.borderLeft,
                                    container.borderRight,
                                    width.oneThird
                                )
                        }
                    >
                        <DateInput
                            date={this.props.date}
                            dateInput={this.state.dateInput}
                            disableOnClickOutside={!this.state.dateInput.visible}
                            fetchSearchResultsAfterSearchParamChange={this.props.fetchSearchResultsAfterSearchParamChange}
                            onHideDateInput={this.handleHideDateInput}
                            onShowDateInput={this.handleShowDateInput}
                            idSuffix="Large"
                            lang={this.props.lang}
                            selectDate={this.props.selectDate}
                            userLang={this.props.userLang}
                        />
                    </div>
                    <div className={css(display.tableCell, position.relative, width.oneThird)}>
                        <GuestInput
                            disableOnClickOutside={!this.state.guestInput.visible}
                            guests={this.props.guests}
                            handleClick={this.onGuestOptionClick}
                            lang={this.props.lang}
                            handleToggleGuestPanel={this.toggleGuestPanel}
                            guestPanelOpen={this.state.guestInput.visible}
                        />
                        <div
                            className={
                                this.state.guestInput.visible ?
                                    css(input.focusUnderline, styles.showUnderline) :
                                    css(input.focusUnderline)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiUrl: state.config.apiUrl,
    date: state.searchParams.date ? state.searchParams.date : '',
    guests: state.searchParams.guests,
    lang: state.lang,
    location: state.searchParams.location,
    tagLabel: state.tagLabel,
    tags: state.tags,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => {
    return {
        fetchSearchResultsAfterSearchParamChange: (apiUrl, userLang, paramObj, trackingCookieId) => {
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            delete paramsObj.page;
            paramsObj[paramObj.paramSlug] = paramObj.paramValue;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true));
        },
        fetchSearchResultsAfterTagParamChange: (apiUrl, userLang, tag, trackingCookieId) => {
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            delete paramsObj.page;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true));
        },
        fetchSearchResultsAfterLocationChange: (apiUrl, userLang, location, lat, lng, trackingCookieId) => {
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            paramsObj.lat = lat;
            paramsObj.lon = lng;
            delete paramsObj.ne_lat;
            delete paramsObj.ne_lon;
            delete paramsObj.sw_lat;
            delete paramsObj.sw_lon;
            delete paramsObj.page;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true, true));
        },
        selectDate: value =>
            dispatch(filterActions.selectDate(value)),
        selectTag: tag =>
            dispatch(filterActions.selectTag(tag)),
        selectGuests: value =>
            dispatch(filterActions.selectGuests(value)),
        selectLocation: value =>
            dispatch(filterActions.selectLocation(value)),
        setTagLabel: tagLabel =>
            dispatch(filterActions.setTagLabel(tagLabel))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarLarge);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/SearchBarLarge.jsx